import { render, staticRenderFns, recyclableRender, components } from "./uni-load-more.vue?vue&type=template&id=90d4256a&"
var renderjs
import script from "./uni-load-more.vue?vue&type=script&lang=js&"
export * from "./uni-load-more.vue?vue&type=script&lang=js&"
import style0 from "./uni-load-more.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uni-load-more/components/uni-load-more/uni-load-more.vue"
export default component.exports